export class Configuration {
    id: string;
    name: string;
    type: string;
    data: any;
}
